import {isApiException} from '@dms/api/utils';

import {ApiError, isFetchBaseQueryError} from 'shared/web';

const TEAM_HAS_INTEREST_ASSIGNMENT_CONDITIONS_CODE = 'DMS-CO-TM-0016';

export function isTeamDeleteBlockedByConditions(error: ApiError): boolean {
  if (!isFetchBaseQueryError(error) || !isApiException(error.data)) {
    return false;
  }

  return error.data.errors.some(
    (apiError) => apiError.code === TEAM_HAS_INTEREST_ASSIGNMENT_CONDITIONS_CODE
  );
}
